var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance-value"},[_c('p',[_vm._v(_vm._s(_vm.title))]),(_vm.waiting)?_c('v-skeleton-loader',{attrs:{"type":"text"}}):_c('span',{style:({ color: [_vm.value < 0 ? '#EF8A97' : '#63B9F2'] })},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.value))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }